import SearchField from './SearchField';
import SearchFieldContainer from './SearchField.container';

export default SearchFieldContainer(SearchField);
